<p-toast></p-toast>
<p-confirmDialog
  rejectButtonStyleClass="p-button-secondary"
  acceptButtonStyleClass="p-button-danger">
</p-confirmDialog>

@if (loadingService.loading()) {
<div class="global-loading-overlay">
  <p-progressSpinner class="global-spinner" strokeWidth="4" />
</div>
}
@if (showNavbar) {
<app-navbar></app-navbar>
}
<div
  class="app-layout"
  [class.with-navbar]="showNavbar"
  [class.with-sidebar]="showSidebar"
  [class.minimal-shell]="!showNavbar">
  @if (showSidebar) {
  <app-sidebar></app-sidebar>
  }
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>